/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Phase_PrepareInputs */

const en_nav_phase_prepare = /** @type {(inputs: Nav_Phase_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepare`)
};

const de_nav_phase_prepare = /** @type {(inputs: Nav_Phase_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorbereiten`)
};

const fr_nav_phase_prepare = /** @type {(inputs: Nav_Phase_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparer`)
};

const es_nav_phase_prepare = /** @type {(inputs: Nav_Phase_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparar`)
};

const it_nav_phase_prepare = /** @type {(inputs: Nav_Phase_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepara`)
};

const nl_nav_phase_prepare = /** @type {(inputs: Nav_Phase_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorbereiden`)
};

const pl_nav_phase_prepare = /** @type {(inputs: Nav_Phase_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przygotuj`)
};

const fi_nav_phase_prepare = /** @type {(inputs: Nav_Phase_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valmistele`)
};

const da_nav_phase_prepare = /** @type {(inputs: Nav_Phase_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forbered`)
};

const sv_nav_phase_prepare = /** @type {(inputs: Nav_Phase_PrepareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förbered`)
};

/**
* | output |
* | --- |
* | "Prepare" |
*
* @param {Nav_Phase_PrepareInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_phase_prepare = /** @type {((inputs?: Nav_Phase_PrepareInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Phase_PrepareInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_phase_prepare(inputs)
	if (locale === "fr") return fr_nav_phase_prepare(inputs)
	if (locale === "es") return es_nav_phase_prepare(inputs)
	if (locale === "it") return it_nav_phase_prepare(inputs)
	if (locale === "nl") return nl_nav_phase_prepare(inputs)
	if (locale === "pl") return pl_nav_phase_prepare(inputs)
	if (locale === "fi") return fi_nav_phase_prepare(inputs)
	if (locale === "da") return da_nav_phase_prepare(inputs)
	if (locale === "sv") return sv_nav_phase_prepare(inputs)
	return en_nav_phase_prepare(inputs)
});